// extracted by mini-css-extract-plugin
module.exports = {"arrow":"arrow_arrow__byr3v","active":"arrow_active__YyEYr"};